import { isAuth } from '@/services/PermissionService';
import Content from '@/components/layout/Content';
import Names from './names';
import { FINANCE, hasPermission, OWNER, POS_BUSINESS_FINANCE, SUPER_ADMIN } from '@/middlewares/permissions';
export default {
	path: '/finance',
	component: Content,
	children: [
		{
			path: '/finance',
			redirect: '/finance/overview',
		},
		{
			path: 'overview',
			name: Names.FinanceOverview,
			component: () => import('../views/finance/Overview'),
			meta: {
				title: 'Finance',
				middleware: [
					isAuth,
					(nav) => hasPermission(nav, [POS_BUSINESS_FINANCE], [SUPER_ADMIN, OWNER, FINANCE]),
				],
			},
		},
		{
			path: 'invoice/:id',
			name: Names.InvoiceDetails,
			component: () => import('../views/finance/Invoice'),
			meta: {
				title: 'Invoice',
				middleware: [
					isAuth,
					(nav) => hasPermission(nav, [POS_BUSINESS_FINANCE], [SUPER_ADMIN, OWNER, FINANCE]),
				],
			},
		},
		{
			path: 'payments',
			name: Names.Payments,
			component: () => import('../views/finance/Payments'),
			meta: {
				title: 'Payments',
				middleware: [
					isAuth,
					(nav) => hasPermission(nav, [POS_BUSINESS_FINANCE], [SUPER_ADMIN, OWNER, FINANCE]),
				],
			},
		},
		{
			path: 'purchases',
			name: Names.Purchases,
			component: () => import('../views/finance/Purchases'),
			meta: {
				title: 'Purchases',
				middleware: [
					isAuth,
					(nav) => hasPermission(nav, [POS_BUSINESS_FINANCE], [SUPER_ADMIN, OWNER, FINANCE]),
				],
			},
		},
	],
};
